import { createStore } from 'vuex'

export default createStore({
    state: {
        wellData:[],//��������
        isRightCollapse:false,//�ұ���״̬
        isLeftCollapse:false,//�����״̬
        wellgroupData:[],//����ѡ�񾮵�չʾ����
        drillObj:{},//������ȡ����
        mouseWheel:0,//���������¼�
        homeTableData:[],//��ҳ�����ͷ����
        singleWell: [], // �������
        singleWellNum:0,
        isoData:{},
        excelKey:"",//�����ϴ���֤
        warningList:[],//Ԥ���쳣�б�
        warningReadData:{},//Ԥ����ǰread�Ķ���
        isDriing:0,//�Ƿ�Ϊ��ȡ״̬
        isWarDriing:0,//�Ƿ�ΪԤ����ȡ״̬
        isJump:false,//�Ƿ���gis��ת
        busVueHeight:[],//����߶�
        gisJumpRoute:"",//GIS��ת��·��Ŀ��

        activeNames:"1",//�۵�ģ��չ����    chartOptiones.vue
        activeNamesChild: "",//�۵������չ����     chartOptiones.vue

        tabList_moduleid:"",//ģ��id
        keepTime:false,//�Ƿ�ʹ�ñ���ʱ���ʶ
        frameTime:[],//����ʱ��
        origin:"",//�û��ĵ�ַ

        blockData:[],//��������
        fullBankWellData:[],//���е������ݣ����ʵ�Ԫ��
        blockQueryFilter:[],//����ѡ�������ɸѡ����

        wellDataHome:[],//��퓙z������
    },
    mutations: {
    },
    actions: {
    },
    modules: {
    },
    getters:{
        getWellData(state){
            return state.wellData;
        },
        getIsRightCollapse(state){
            return state.isRightCollapse;
        },
        getIsLeftCollapse(state){
            return state.isLeftCollapse;
        },
        getWellgroupData(state){
            return state.wellgroupData;
        },
        getHomeTableData(state){
            return state.homeTableData;
        },
        getBlockData(state){
            return state.blockData;
        },
        getFullBankWellData(state){
            return state.fullBankWellData;
        },
        getWellDataHome(state){
            return state.wellDataHome;
        },
    }
})